import {Component, Input} from '@angular/core';
import {FaqItem} from '../../../module/faq.item';

@Component({
  selector: 'mat-faq',
  template: `
    <mat-toolbar color="primary">{{title}}</mat-toolbar>
    <mat-accordion [displayMode]="displayMode" [multi]="multi"
                   class="faq-container">
      <mat-expansion-panel *ngFor="let faqItem of faqList">
        <mat-expansion-panel-header>{{faqItem.question}}</mat-expansion-panel-header>
        <p>{{faqItem.answer}}</p>
      </mat-expansion-panel>
    </mat-accordion>
  `,
  styles: [`

  `]
})
export class MatFaqComponent {

  @Input()
  title = 'FAQ';

  @Input()
  multi = false;

  @Input()
  displayMode = 'default'; // or flat

  @Input()
  faqList: FaqItem[] = [];

}
